import { render, staticRenderFns } from "./Bglist.vue?vue&type=template&id=7180130c&scoped=true"
import script from "./Bglist.vue?vue&type=script&lang=js"
export * from "./Bglist.vue?vue&type=script&lang=js"
import style0 from "./Bglist.vue?vue&type=style&index=0&id=7180130c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7180130c",
  null
  
)

export default component.exports